import React from 'react';

import styles from './TrustPilot.m.sass';

import {connect} from 'react-redux';
import {fetchOrdersTotal} from '../../ducks/misc';

import cx from 'classnames';

import trustPilotLogoImage from './assets/trustpilot-big.svg';
import trustPilotStarImage from './assets/star-big.svg';
import accountsImage from './assets/accounts.svg';

@connect(({misc}) => ({ordersTotal: misc.ordersTotal}))
export default class TrustPilot extends React.PureComponent {
  render() {
    const {solid, apart, ordersTotal} = this.props;

    return (
      <div className={cx(
        styles.trustPilot,
        {[styles.solid]: solid},
        {[styles.apart]: apart},
      )}>
        <div className={styles.trustPilotWrapper}>
          <div className={styles.trustPilotTop}>
            <a href="#" className={styles.trustPilotWrapper}>
              <img src={trustPilotLogoImage} className={styles.trustPilotLogo} alt="Trustpilot"/>
              <span className={styles.trustPilotStars}>
                <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
                <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
                <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
                <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
                <span className={styles.trustPilotStar}><img src={trustPilotStarImage} alt=""/></span>
              </span>
              <span className={styles.trustPilotExcellent}>Excellent</span>
            </a>
          </div>

          <div className={styles.trustPilotBottom}>
            <div className={styles.boosted}>
              <img src={accountsImage} alt=""/>
              <span className={styles.boostedNumber}>
                {ordersTotal != null && ordersTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
              </span>
              <span className={styles.boostedText}>accounts<br/>boosted</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/trustPilot/TrustPilot.js